window.addEventListener('load', () => {
    const overlay = document.querySelector('.overlay');
    const mobileMenu = document.querySelector('.mobile_menu');
    const burgger = document.getElementById('burgger');

    overlay.addEventListener('click', () => {
        overlay.classList.remove('active');
        mobileMenu.classList.remove('active');
        burgger.classList.remove('active');
    })
})
// window.addEventListener('load', () => {
//     const overlay = document.querySelector('.overlay');
//     const mobileMenu = document.querySelector('.filter_menu');
//     const burgger = document.getElementById('filter');

//     overlay.addEventListener('click', () => {
//         overlay.classList.remove('active');
//         mobileMenu.classList.remove('active');
//         burgger.classList.remove('active');
//     })
// })